import config from '../../../config';

function initCoins (layer) {
  let g = this.g;

  _.each(layer.groups.tiles, (sprite) => {
    sprite.play('coin-spin');
  });
}

export {
  initCoins
};
